module.exports = __webpack_public_path__ + "img/fintech-cover.40667a1b.jpg";